
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";

const SearchInput = ({ params, highlightedResult, onSubmitHandler }) => {

    return (
        <TextField
            {...params}
            placeholder="ISIN, issuer or issuer country"
            onKeyDown={(event) => {
                if (event.code === 'Enter' && highlightedResult) {
                    onSubmitHandler(event, highlightedResult)
                }
            }}
            variant='standard'
            slotProps={{
                input: {
                    ...params.InputProps,
                    type: 'search',
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    disableUnderline: true,
                    style: { minHeight: 60, paddingInline: 30 },
                }
            }}
        />
    );
};

export default SearchInput;